enum GROW2792_ACTIONS {
  PNP_REFRESH_RESET_TOGGLE_SWITCH = 'PNP_REFRESH_RESET_TOGGLE_SWITCH',
  PNP_REFRESH_CHANGE_USERS = 'PNP_REFRESH_CHANGE_USERS',
  PNP_REFRESH_INITIAL_LOAD = 'PNP_REFRESH_INITIAL_LOAD',
  PNP_REFRESH_RESET_ALL = 'PNP_REFRESH_RESET_ALL',
}

export default GROW2792_ACTIONS;
